import { render, staticRenderFns } from "./WidgetFrame.vue?vue&type=template&id=5eacfb8e&"
import script from "./WidgetFrame.vue?vue&type=script&lang=ts&"
export * from "./WidgetFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports